import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";

export default function ClearDataConfirmDialog({ open, onClose, onConfirm }) {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (open) {
      setInputValue("");
    }
  }, [open]);

  if (!open) return null;

  const handleProceed = () => {
    if (inputValue.trim() === "clear") {
      onConfirm();
    }
  };

  return (
    <div className={styles.popUp} style={{ zIndex: 10000 }}>
      <div className={styles.confirmContentWrapper}>
        <div className={styles.headInfoSec}>
          <h2>Clear All Data</h2>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>

        <div className={styles.contentArea}>
          <h3 className={styles.subTitle} style={{ color: "#e50218", fontWeight: "600" }}>
            Are you sure to clear all data from local? Type 'clear'
          </h3>
          <div className={styles.inputRow} style={{ marginTop: "15px" }}>
            <input
              type="text"
              placeholder="Type 'clear'"
              className={styles.amountInput}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.buttonSection}>
          <ButtonGray onClick={onClose}>Cancel</ButtonGray>
          <ButtonRed onClick={handleProceed} disabled={inputValue.trim() !== "clear"}>
            Proceed
          </ButtonRed>
        </div>
      </div>
    </div>
  );
}
